<template>
  <div class="tabs hvh-flex">
    <div class="tab" :class="{ active: value === key }" @click="$emit('input', key)" v-for="key in Object.keys(items)" :key="key">
      <v-icon class="mr-1" :color="value === key ? 'white' : '#666adf'" v-if="items[key].icon">{{ items[key].icon }}</v-icon>
      {{ key }}
    </div>
  </div>
</template>

<script>
export default {
  props: ['value', 'items'],
}
</script>


<style lang="scss" scoped>
.tabs {
  background-color: #f5fbfb;
  box-shadow: 0 -1px 1px 0px #c6e6e5;
  padding: 0 3px;
  .tab {
    display: flex;
    align-items: flex-end;
    padding: 10px 12px;

    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.3px;
    line-height: 21px;

    text-transform: uppercase;
    background-color: #f5fbfb;

    cursor: pointer;

    &.active {
      border-radius: 7px;
      background-color: #8d90f4;
      color: white;
    }
  }
}
</style>